/**
 * ItemList schema for the Raskh vs Anki vs Quizlet vs ChatGPT comparison.
 *
 * Each element mirrors a capability row in the Comparison section. Names
 * intentionally match the EN copy in `landing.comparison.rows[].capability`
 * so search engines and AI assistants can map the snippet to the rendered
 * table.
 */

const items = [
  'Input: upload your own PDF / notes',
  'Generates flashcards from source automatically',
  'Asks you to explain it back by voice',
  "Tracks what you've forgotten per concept",
  'Mind map from same upload',
  'Spaced repetition',
  'Streak / daily pressure',
  'Arabic — Quran, Hadith, OCR',
  'AI podcast / audio recap',
  'Best for',
];

export const comparisonItemList = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Raskh vs Anki vs Quizlet vs ChatGPT comparison',
  itemListElement: items.map((name, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name,
  })),
};

export default comparisonItemList;
